import { Link, Navigate } from "react-router-dom";
import { docSections } from "@/content/docs";

export default function DocsIndex() {
  // Redirect to first section
  return <Navigate to={`/docs/${docSections[0].slug}`} replace />;
}
